import { useEffect, useState } from 'react';

export const DICE_ROLL_DURATION = 1050;

const dotPatterns = {
  1: [5],
  2: [1, 9],
  3: [1, 5, 9],
  4: [1, 3, 7, 9],
  5: [1, 3, 5, 7, 9],
  6: [1, 3, 4, 6, 7, 9],
};

function Die({ value, rolling, delay }) {
  return (
    <span className={`die ${rolling ? 'is-rolling' : ''}`} style={{ animationDelay: `${delay}ms` }} aria-label={`На кубике ${value}`}>
      {Array.from({ length: 9 }, (_, index) => <i key={index} className={dotPatterns[value]?.includes(index + 1) ? 'is-visible' : ''} />)}
    </span>
  );
}

export function Dice({ dice, compact = false, board = false, animate = true }) {
  const [dieOne, dieTwo] = dice.values;
  const [displayValues, setDisplayValues] = useState(() => (
    animate && dice.sequence > 0 ? [((dice.sequence + 1) % 6) + 1, ((dice.sequence + 4) % 6) + 1] : dice.values
  ));
  const [rolling, setRolling] = useState(animate && dice.sequence > 0);

  useEffect(() => {
    if (!animate || dice.sequence === 0) return undefined;
    let frame = 0;
    const interval = window.setInterval(() => {
      frame += 1;
      setDisplayValues([
        ((dice.sequence + frame * 2) % 6) + 1,
        ((dice.sequence + frame * 3 + 2) % 6) + 1,
      ]);
    }, 110);
    const finish = window.setTimeout(() => {
      window.clearInterval(interval);
      setDisplayValues([dieOne, dieTwo]);
      setRolling(false);
    }, DICE_ROLL_DURATION);
    return () => {
      window.clearInterval(interval);
      window.clearTimeout(finish);
    };
  }, [animate, dice.sequence, dieOne, dieTwo]);

  return (
    <div className={`dice ${compact ? 'dice--compact' : ''} ${board ? 'dice--board' : ''} ${rolling ? 'dice--rolling' : ''}`} key={dice.sequence} data-rolling={rolling}>
      <Die value={displayValues[0]} rolling={rolling} delay={0} />
      <Die value={displayValues[1]} rolling={rolling} delay={90} />
      <span className="dice__total">{rolling ? '…' : dice.total}</span>
    </div>
  );
}
